var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "800" },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.isNew ? "Add new condition" : "Edit condition") +
                  " "
              )
            ])
          ]),
          _c(
            "v-card-text",
            { staticStyle: { color: "black" } },
            [
              _c(
                "v-form",
                {
                  ref: "conditionForm",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-select", {
                                attrs: {
                                  items: Object.values(
                                    _vm.transportEventConditionProperties
                                  ),
                                  label: "Value",
                                  rules: [_vm.requiredRule],
                                  required: ""
                                },
                                model: {
                                  value: _vm.condition.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.condition, "value", $$v)
                                  },
                                  expression: "condition.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-select", {
                                attrs: {
                                  items: Object.values(_vm.comparators).filter(
                                    function(p) {
                                      return p !== 0
                                    }
                                  ),
                                  label: "Comparator",
                                  rules: [_vm.requiredRule],
                                  required: ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("comparatorToSymbol")(item)
                                            ) +
                                            " "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("comparatorToSymbol")(item)
                                            ) +
                                            " "
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.condition.comparator,
                                  callback: function($$v) {
                                    _vm.$set(_vm.condition, "comparator", $$v)
                                  },
                                  expression: "condition.comparator"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _vm.condition.value === "EventType"
                                ? _c("v-select", {
                                    attrs: {
                                      items: _vm.eventTypeItems,
                                      label: "Target value",
                                      rules: [_vm.requiredRule],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.condition.target,
                                      callback: function($$v) {
                                        _vm.$set(_vm.condition, "target", $$v)
                                      },
                                      expression: "condition.target"
                                    }
                                  })
                                : _vm.condition.value === "WelfareTripType"
                                ? _c("v-select", {
                                    attrs: {
                                      items: _vm.welfareTripTypeItems,
                                      label: "Target value",
                                      rules: [_vm.requiredRule],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.condition.target,
                                      callback: function($$v) {
                                        _vm.$set(_vm.condition, "target", $$v)
                                      },
                                      expression: "condition.target"
                                    }
                                  })
                                : _c("v-text-field", {
                                    attrs: {
                                      label: "Target value",
                                      rules: [_vm.requiredRule],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.condition.target,
                                      callback: function($$v) {
                                        _vm.$set(_vm.condition, "target", $$v)
                                      },
                                      expression: "condition.target"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "pb-4" },
            [
              _c("v-spacer"),
              _vm.isNew
                ? _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "success" },
                      on: { click: _vm.createCondition }
                    },
                    [_vm._v(" Add condition ")]
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "primary" },
                      on: { click: _vm.saveCondition }
                    },
                    [_vm._v(" Save changes ")]
                  ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }